import React from 'react';
import { ScrollArea } from '~/primitives/scroll-area';

interface ListTagsSelectorProps {
    availableItems: string[];
    itemStates: { [key: string]: boolean };
    setItemStates: (itemStates: { [key: string]: boolean }) => void;
    allItemsDisplayed?: boolean;
}

const ListTagsSelector: React.FC<ListTagsSelectorProps> = ({
    availableItems,
    itemStates,
    setItemStates,
}) => {
    const setItem = (item: string, state?: boolean) => {
        const updatedItemStates = { ...itemStates };

        if (state === undefined) delete updatedItemStates[item];
        else updatedItemStates[item] = state;

        setItemStates(updatedItemStates);
    };

    const handleItemClick = (item: string) => {
        const value =
            itemStates[item] === undefined
                ? true
                : itemStates[item]
                  ? false
                  : undefined;
        setItem(item, value);
    };

    const sortedItems = [
        ...Object.keys(itemStates).sort(
            (a, b) => (itemStates[b] ? 1 : -1) - (itemStates[a] ? 1 : -1),
        ),
        ...availableItems.filter((item) => !(item in itemStates)),
    ];

    return (
        <div className="bg-background-dark  lg:h-[30vh] rounded-lg p-4 w-full">
            <ScrollArea className="h-full">
                <div className="flex flex-wrap gap-2">
                    {sortedItems.map((item) => (
                        <button
                            key={item}
                            onClick={() => handleItemClick(item)}
                            className={`px-2 py-1 clamp-[text-xs-sm-clamp] font-medium rounded cursor-pointer transition-colors ${
                                itemStates[item] === undefined
                                    ? 'bg-background-light text-secondary-light hover:bg-secondary hover:text-secondary-foreground'
                                    : itemStates[item]
                                      ? 'bg-confirm text-secondary-foreground hover:bg-confirm-transparent'
                                      : 'bg-destructive text-secondary-foreground hover:bg-destructive-transparent'
                            }`}
                        >
                            {item}
                        </button>
                    ))}
                </div>
            </ScrollArea>
        </div>
    );
};

export default ListTagsSelector;
